import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

import Index from '../pages/index/index.vue';
import IndexLogin from '../pages/index/login.vue';
import IndexHome from '../pages/index/home/home.vue';
import IndexDownload from '../pages/index/download/download.vue';
import IndexGuide from '../pages/index/guide/guide.vue';
import IndexSciencePark from '../pages/index/science_park/science_park.vue';
import IndexRecoveryCase from '../pages/index/recovery_case/recovery_case.vue';
import IndexAboutUs from '../pages/index/about_us/about_us.vue';
import IndexNews from '../pages/index/detail/news.vue';
// import IndexService from '../pages/index/service/service.vue';
import IndexPayStatus from '../pages/index/pay_status.vue';

import Course from '../pages/course/course.vue';

/******************************* 导出数据 ********************************/
export default new Router({
	mode: "history",
	routes: [{
		path: "/index",
		component: Index,
		children: [{
			path: "/index/login",
			component: IndexLogin
		}, {
			path: "/index/home",
			component: IndexHome
		}, {
			path: "/index/download",
			component: IndexDownload
		}, {
			path: "/index/guide",
			component: IndexGuide
		}, {
			path: "/index/science_park",
			component: IndexSciencePark
		}, {
			path: "/index/recovery_case",
			component: IndexRecoveryCase
		}, {
			path: "/index/about_us",
			component: IndexAboutUs
		}, {
			path: "/index/news",
			component: IndexNews
		}, {
			path: "/index/pay_status",
			component: IndexPayStatus
		}, {
			path: '/index/*',
			redirect: '/index/home'
		}, {
			path: '/index',
			redirect: '/index/home'
		}, ]
	}, {
		path: '/course',
		component: Course
	}, {
		path: '*',
		redirect: '/index'
	}]
})
